import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"

const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LinksContainer>
            <Link href="tel:+33629696525">Appeler</Link>
            <Link href="mailto:nathanchateau@gmail.com">Envoyer un email</Link>
            <Link href="https://www.linkedin.com/in/nathan-chateau/">Linkedin</Link>
            <Link href="https://www.malt.fr/profile/nathanchateau">Malt</Link>
            <Link href="https://github.com/nathan-ch">Github</Link>
          </LinksContainer>
          <CopyrightText>
            &copy; Copyright 2020, Nathan Chateau, tous droits réservés.
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
